module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-row', {
    staticClass: "margin-b-10 margin-10",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24
    }
  }, [_c('v-excise-table', {
    attrs: {
      "list": _vm.entries,
      "noDataMessage": _vm.$t('static.defaultText.exciseEntry.noDataMsg'),
      "translation": "static.exciseEntry.table",
      "group_key_id": "exciseGroup",
      "additional_key_code": "exciseAdditionalCode",
      "packaging_type_id": "excisePackaging",
      "basic_id": "exciseBasic",
      "rowKey": "id,additionalCodeDesc",
      "loading": _vm.loading,
      "update_list": _vm.updateList,
      "link": _vm.openLink,
      "linkKey": "excisableType"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a0d2ecb","hasScoped":true}!./src/app/components/exciseEntryModal/exciseEntryModal.html
// module id = 2991
// module chunks = 1